export default __webpack_public_path__ + "static/media/ISSO CLASS-8 EXAM PATTERN 2026-27.469828b8.pdf";